<template>
  <div class="public-content order">
    <div class="breadcrumb">积分收支明细</div>
    <div class="right-main">
      <!-- 查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col v-permission="'oms:admin:order:one'" :span="6">
            <el-form-item label="订单号:">
              <el-input v-model="formInline.orderNo" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeCode" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
						<el-form-item label="平台类型:">
							<el-select v-model="formInline.storeType" placeholder="请选择" clearable>
								<el-option label="" value="">全部</el-option>
								<el-option v-for="item in basicsInfo.storeTypeList" :key="item.id" :label="item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
          <el-col :span="6">
            <el-form-item label="收支类型:">
              <el-select v-model="formInline.changeType" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="收入" value="CLAIM"></el-option>
                <el-option label="抵扣" value="DEDUCT"></el-option>
                <el-option label="充值" value="RECHARGE"></el-option>
                <el-option label="消费" value="USE"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="fn-right form-btn">
          <el-button @click="showChangeDilog" round type="primary">积分变动</el-button>
          <el-button @click="showSetRule" round type="primary">积分设置</el-button>
          <el-button @click="exportExcel" round v-if="$hasPermission('oms:admin:order:export')">导出Excel</el-button>
          <el-button @click="(queryInfo.pageNum = 1), onSubmit()" round>查询</el-button>
        </div>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border :row-class-name="rowClassName" style="width: 100%" :empty-text="'暂无数据'">
          <el-table-column label="订单号" fixed="left" min-width="210px">
            <template slot-scope="scope">
              <span v-if="$hasPermission('oms:admin:order:one')" @click="orderInfo(scope.row)" :class="canCheck(scope.row) ? 'color-blue' : ''">{{ scope.row.orderNo ? scope.row.orderNo :
                scope.row.flowNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="storeCode" label="平台号" min-width="130px"></el-table-column>
          <el-table-column prop="storeName" label="平台名称" min-width="130px"></el-table-column>
          <el-table-column prop="salesmanName" label="业务" min-width="130px"></el-table-column>
          <el-table-column prop="changeTypeName" label="收支类型">
            <template slot-scope="scope">
              <span> {{ scope.row.changeTypeName }} </span>
            </template>
          </el-table-column>
          <el-table-column prop="changeNumber" label="积分数值" min-width="130px"></el-table-column>
          <el-table-column prop="createdTime" label="创建日期" min-width="170px"></el-table-column>
          <el-table-column prop="afterChangeNumber" label="当前积分" min-width="130px"></el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo="queryInfo"></v-pagination>
    </div>
    <el-dialog :close-on-click-modal="false" title="积分生成规则" :visible.sync="dialogVisible" :modal="false" width="500px">
      <div class="content_box">
        <div>基本规则：每消费 <el-input v-model="setPoints.consumptionAmount" placeholder="" clearable style="width:80px;margin: 0 10px;"></el-input>元，送<el-input v-model="setPoints.rewardPoints"
            placeholder="" clearable style="width:80px;margin: 0 10px;"></el-input>积分 </div>
        <div style="margin-top: 20px;margin-left: 80px;">产品价格中1元当<el-input v-model="setPoints.exchangeRate" placeholder="" clearable style="width:80px;margin: 0 10px;"></el-input>积分</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submit" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { getByOmsOrderNo } from '@/api/finance'
import { storeTypeGetStoreTypeList, storeQueryListByCode, getSalesmanByFullName, storeQueryListByName, getAllUsersByUserName, getPointRules, setPointRules, getPointList, pointExport } from '@/api/crm'
export default {
  name: 'order',
  components: {
    VPagination
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)

        if (val) {
          this.formInline.createTimeBegin = val[0] + ' 00:00:00'
          this.formInline.createTimeEnd = val[1] + ' 23:59:59'
        } else {
          this.formInline.createTimeBegin = ''
          this.formInline.createTimeEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      currentPointRules: {},
      setPoints: {
        consumptionAmount: '',
        rewardPoints: '',
        exchangeRate: ''
      },
      dialogVisible: false,
      userList: [],
      salemanList: [],
      storeListByCode: [],
      queryInfo: {
        total: 0,
        pageNum: 1, // 当前显示第几页
        pageSize: 10 // 每一页显示条数
      },
      formInline: {
        orderNo: null, // 订单号
        changeType: null,
        createTimeBegin: null,
        createTimeEnd: null,
        storeId: null,
        storeCode: '',
        storeName: ''
      },
      tableData: [],
      basicsInfo: {
        storeId: '',
        storeCode: '',
        storeName: '',
        fullName: '',
        storeTypeList: []
      },
      storeType: [], // 平台类型
      value2:
        this.$route.query.paymentStatus === 'UNPAID'
          ? ''
          : [
            this.$moment()
              .subtract(6, 'months')
              .format('YYYY-MM-DD'),
            this.$moment().format('YYYY-MM-DD')
          ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      typeList: [
        {
          id: 'CLAIM',
          name: '收入'
        },
        {
          id: 'DEDUCT',
          name: '抵扣'
        },
        {
          id: 'RECHARGE',
          name: '充值'
        },
        {
          id: 'USE',
          name: '消费'
        }
      ]
    }
  },
  created () {
    getPointRules('WD').then(res => {
      if (res.data.success) {
        this.currentPointRules = res.data.data
        this.setPoints = Object.assign({}, res.data.data)
      }
    })
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.userList = JSON.parse(sessionStorage.getItem('userList'))
      this.value2[0] = this.formInline.createTimeBegin.split(' ')[0]
      this.value2[1] = this.formInline.createTimeEnd.split(' ')[0]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('userList')
    }
    if (this.$route.query.paymentStatus === 'UNPAID') {
      this.formInline.paymentStatus = 'UNPAID'
      this.formInline.orderStatus = 'SUBMITTED'
      // this.value2 = []
    }
    this.onSubmit(this.queryInfo)
    this.getBasicsInfo()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    canCheck (row) {
      return row.changeType === 'claim' || row.changeType === 'use'
    },
    submit () {
      // 设置积分规则
      setPointRules(this.setPoints).then(res => {
        if (res.data.success) {
          this.dialogVisible = false
          this.currentPointRules = Object.assign({}, this.setPoints)
        }
      })
    },
    orderInfo (row) {
      if (!this.canCheck(row)) {
        return
      }
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('userList', JSON.stringify(this.userList))
      this.$router.push({ path: '/orderdetail', query: { orderNo: row.orderNo, way: 1 } })
    },
    // 查看发票
    invoicePage (val) {
      console.log('vaaaaalll', val)
      getByOmsOrderNo(val).then(res => {
        console.log(res)
        let receipt = res?.data?.data?.receipt
        if (receipt) {
          window.open(receipt.url ? receipt.url : '')
        }
      })
    },
    getBasicsInfo () {
      storeTypeGetStoreTypeList().then(res => {
        this.basicsInfo.storeTypeList = res.data.data
        this.storeType = []
        let storeTypeData = res.data.data
        const montage = (storeTypeData) => {
          let obj = {}
          for (let v of storeTypeData) {
            obj[v.code] = v.name
          }
          return obj
        }
        this.storeType = montage(storeTypeData)
      })
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('userList', JSON.stringify(this.userList))
      }
      if (this.formInline.changeType == '') {
        delete this.formInline.changeType
      }
      getPointList({ ...this.queryInfo, ...this.formInline }).then(res => {
        if (res.data.success) {
          res.data.data.records.forEach((el, idx) => {
            el.changeTypeName = this.typeList.find(item => item.id.toLowerCase() === el.changeType).name
          })
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    getOrderStatus (orderId) {
      this.$refs.orderDialogRef.show(orderId)
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = JSON.parse(JSON.stringify(this.formInline))
      Object.keys(param).forEach(key => (param[key] === '' || param[key] === null) && delete param[key])
      pointExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = event => {
          let a = document.createElement('a')
          let _fileName = '积分收支明细' + '.xls'
          if (this.value2.length) {
            _fileName = '积分收支明细' + this.value2[0] + '-' + this.value2[1] + '.xls'
          }
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    handleSelect (item) {
      this.formInline.storeId = item.id
      this.basicsInfo.storeName = item.companyName
    },
    selectUserList (val) {
      if (val.trim()) {
        getAllUsersByUserName(val).then(res => {
          if (res.data.success) {
            this.userList = res.data.data
          }
        })
      }
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    // querySearchAsync(queryString, cb) {
    //   storeQueryListByCode(queryString).then(res => {
    //     res.data.data.forEach(item => {
    //       item.value = item.code
    //     });
    //     cb(res.data.data)
    //   })
    // },
    SelectStoreName (item) {
      this.formInline.storeId = item.id
      this.basicsInfo.storeCode = item.code
    },
    queryStoreNameAsync (queryString, cb) {
      storeQueryListByName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    selectFullName (item) {
      this.formInline.salesmanId = item.id
    },
    queryFullNameAsync (queryString, cb) {
      // 改成业务的模糊查询
      getSalesmanByFullName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.fullName
        })
        cb(res.data.data)
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    },
    showSetRule () {
      if (this.currentPointRules && this.currentPointRules.id) {
        this.setPoints = Object.assign({}, this.currentPointRules)
      }
      this.dialogVisible = true
    },
    showChangeDilog () {
      this.$router.push({ path: '/changePoints' })
    }
  }
}
</script>
<style scoped lang="less">
@import 'index';
@deep: ~'>>>';
</style>
